/**
 * Regional bridal look cards — ids match backend enterprise/makeup_flux_prompt_v3/bridal_looks.py
 * FLUX styling text for mapped looks loads from repo prompt/*.odt at generate time.
 */

import { buildMakeupLabFromPresetSlots } from './makeupFluxV3TimePresets';

export const MAKEUP_V3_BRIDAL_LOOK_PRESET_ID = 'bridal-look';

/** Light enhance-only face lab — no hard glam. */
const BRIDAL_LIGHT_FACE_SLOTS = {
  foundation: { optionId: 'auto-skin', intensity: 26, finishId: 'satin' },
  concealer: { optionId: 'auto-concealer', intensity: 16 },
  blush: { optionId: 'auto-blush', intensity: 30, finishId: 'satin' },
  eyeshadow: { optionId: 'auto-eyeshadow', intensity: 22, finishId: 'satin' },
  eyeliner: 'minimal',
  eyelash: 'natural',
  lipstick: { optionId: 'auto-lip', intensity: 34 },
  highlighter: 'none',
  contour: 'none',
  eyebrows: 'match',
};

export const MAKEUP_V3_BRIDAL_LOOKS = [
  {
    id: 'north_indian_bride',
    label: 'North Indian Bride',
    subtitle: 'Vermilion lehenga · kundan-polki',
    ornamentId: 'north_indian_kundan',
    promptOdt: true,
  },
  {
    id: 'minimal_pastel_bride',
    label: 'Minimal Pastel Bride',
    subtitle: 'Blush lehenga · kundan-pearl',
    ornamentId: 'mughal_inspired',
    promptOdt: true,
  },
  {
    id: 'cocktail_look',
    label: 'Cocktail Look',
    subtitle: 'Saree-gown · statement earrings',
    ornamentId: 'none',
    promptOdt: true,
  },
  {
    id: 'mehendi_look',
    label: 'Mehendi Look',
    subtitle: 'Pistachio lehenga · floral jewellery',
    ornamentId: 'none',
    promptOdt: true,
  },
  {
    id: 'malayalam_bride',
    label: 'Malayalam Bride',
    subtitle: 'Kasavu saree · temple jewellery',
    ornamentId: 'kerala_traditional',
    promptOdt: true,
  },
  {
    id: 'christian_bride',
    label: 'Christian Bride',
    subtitle: 'White lace gown · veil · bouquet',
    ornamentId: 'none',
    promptOdt: true,
  },
  {
    id: 'tamil_bride',
    label: 'Tamil Bride',
    subtitle: 'Kanchipuram silk · temple gold',
    ornamentId: 'tamil_kalyanam',
    promptOdt: true,
  },
  {
    id: 'iyengar_bride',
    label: 'Iyengar Bride',
    subtitle: 'Thiruman · Kanchipuram · temple gold',
    ornamentId: 'iyengar_vaishnava',
    promptOdt: false,
  },
  {
    id: 'telugu_bride',
    label: 'Telugu Bride',
    subtitle: 'Kanchipuram silk · temple gold',
    ornamentId: 'telugu_bridal',
    promptOdt: true,
  },
  {
    id: 'kannada_bride',
    label: 'Kannada Bride',
    subtitle: 'Cream-maroon silk · temple gold',
    ornamentId: 'kannada_bridal',
    promptOdt: false,
  },
  {
    id: 'maharashtrian_bride',
    label: 'Maharashtrian Bride',
    subtitle: 'Paithani · mundavalya · nath',
    ornamentId: 'maharashtrian',
    promptOdt: false,
  },
  {
    id: 'reception_glam',
    label: 'Reception Glam',
    subtitle: 'Designer saree · evening glam',
    ornamentId: 'reception_glam',
    promptOdt: true,
  },
  {
    id: 'friend_of_bride',
    label: 'Friend of Bride',
    subtitle: 'Guest glam · Hollywood waves',
    ornamentId: 'friend_of_bride',
    promptOdt: true,
  },
  {
    id: 'punjabi_bride',
    label: 'Punjabi Bride',
    subtitle: 'Red lehenga · chooda · nath',
    ornamentId: 'punjabi_bridal',
    promptOdt: false,
  },
  {
    id: 'rajasthani_bride',
    label: 'Rajasthani Bride',
    subtitle: 'Borla · odhani · kundan',
    ornamentId: 'rajasthani',
    promptOdt: false,
  },
  {
    id: 'bengali_bride',
    label: 'Bengali Bride',
    subtitle: 'Banarasi · mukut · shankha-pola',
    ornamentId: 'bengali',
    promptOdt: false,
  },
];

export function bridalLookById(lookId) {
  return MAKEUP_V3_BRIDAL_LOOKS.find((l) => l.id === lookId) || null;
}

export function makeupLabForBridalLook() {
  return buildMakeupLabFromPresetSlots(BRIDAL_LIGHT_FACE_SLOTS);
}
